import * as React from "react";
import {
    Theme,
    makeStyles,
    StandardProps,
    MenuItem,
    Menu
} from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { StyleClassKey } from "js/react/typescript";
import { RenderWithConfirmation } from "js/react/components";

const styles = makeStyles((theme: Theme) => ({
    name: {
        display: "inline-block",
        fontSize: "0.85rem",
        color: theme.palette.primary.main
    },
    downIcon: {
        marginLeft: theme.spacing(1),
        color: theme.palette.grey["500"]
    },
    root: {
        display: "flex",
        alignItems: "center",
        verticalAlign: "middle",
        justifyContent: "center",
        width: "110px",
        border: `1px solid ${theme.palette.primary.main}`,
        borderRadius: theme.spacing(0.4),
        padding: theme.spacing(0.5, 1.5),

        "&:hover": {
            cursor: "pointer"
        }
    }
}));

export type MediaActionsMenuClassKey = StyleClassKey<typeof styles>;

export interface MediaActionsMenuProps
    extends StandardProps<{}, MediaActionsMenuClassKey> {
    onDelete: () => void;
}

const Component = (props: MediaActionsMenuProps) => {
    const classes = styles(props);
    const { onDelete, ...rest } = props;
    const [menuOpened, setMenuOpened] = useState(false);
    const anchorEl = React.useRef<HTMLDivElement>();

    return (
        <React.Fragment>
            <div className={classes.root} onClick={() => setMenuOpened(true)}>
                <Typography
                    variant={"h6"}
                    ref={anchorEl}
                    component={"span"}
                    className={classes.name}
                >
                    {"Actions"}
                </Typography>
                <FontAwesomeIcon
                    icon={["fal", "chevron-down"]}
                    className={classes.downIcon}
                />
            </div>
            <RenderWithConfirmation
                onConfirm={onDelete}
                dialogMessage={
                    "Please confirm that you want to delete all the selected files and directories."
                }
                permanent={true}
                dialogTitle={"Delete file(s)?"}
            >
                {props => (
                    <Menu
                        anchorEl={anchorEl.current}
                        keepMounted
                        open={menuOpened}
                        onClose={() => setMenuOpened(false)}
                    >
                        <MenuItem onClick={props.askConfirmation}>
                            {"Delete"}
                        </MenuItem>
                    </Menu>
                )}
            </RenderWithConfirmation>
        </React.Fragment>
    );
};

Component.displayName = "MediaActionsMenu";

export const MediaActionsMenu = React.memo(Component);

export default MediaActionsMenu;
